import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNotice(code) {
  const queryKey = ['notices', code];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      try {
        return await platformApi.get(`notices/${code}`, { signal }).json();
      } catch (error) {
        if (error.data?.statusCode === 404) {
          return null;
        } else {
          throw error;
        }
      }
    },
    enabled: !!code && code !== 'new',
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
